module.exports = __webpack_public_path__ + "img/icon_converter_on.2c45d4e2.png";